import React from 'react'
import { Button, Typography } from 'antd'
import { IFrontVariation } from 'models/product'
import { DownOutlined, EditFilled, PlusOutlined } from '@ant-design/icons'
import styles from '../ProductForm.module.scss'

interface ISelectProductProps {
  variation?: IFrontVariation
  hasError?: boolean
  openUpdateProductModal: () => void
  openChooseProductModal: () => void
  openCreateProductModal: () => void
}

export const SelectProduct: React.FC<ISelectProductProps> = React.memo(({ variation, hasError, openUpdateProductModal, openChooseProductModal, openCreateProductModal }) => {
  return (
    <div className={styles.variantsActionsRow} style={{ width: '100%' }}>
      {variation?.product ? (
        <>
          {/* название занимает всю свободную ширину ячейки без ограничения,
              полный текст показывается во всплывающей подсказке */}
          <Typography.Text
            style={{ flex: 1, minWidth: 0, fontSize: 14 }}
            ellipsis={{ tooltip: variation.product.name }}
          >
            {variation.product.name}
          </Typography.Text>
          {/* кнопка прижата к правому краю ячейки (к блоку характеристик),
              с воздухом вокруг */}
          <div style={{ marginLeft: 'auto', padding: '0 4px 0 8px' }}>
            <Button
              type='primary'
              htmlType='button'
              size='small'
              icon={<EditFilled style={{ fontSize: 14 }} />}
              onClick={openUpdateProductModal}
            />
          </div>
        </>
      ) : (
        <>
          <Typography.Link
            className={hasError ? styles.selectProductError : undefined}
            style={{ marginRight: 10 }}
            onClick={openChooseProductModal}
          >
            <span>Выбрать товар</span>
            <DownOutlined style={{ paddingLeft: 4 }} />
          </Typography.Link>
          <Button
            type='primary'
            htmlType='button'
            size='small'
            style={{ marginLeft: 'auto' }}
            icon={<PlusOutlined style={{ fontSize: 14 }} />}
            onClick={openCreateProductModal}
          >
            Создать
          </Button>
        </>
      )}
    </div>
  )
})
